import { hex } from "wcag-contrast";
import { Colors } from "../colors";

export function findContrastColor(backgroundColor: string) {
  if (hex(backgroundColor, Colors.Neutral600) > 4.5) {
    return Colors.Neutral600;
  }
  return Colors.Neutral0;
}
